module.exports = __webpack_public_path__ + "img/porch-swing.4bae1f7b.jpg";